export function getLogger() {
  var log = require('loglevel').getLogger('cerberus');
  log.setLevel(process.env.REACT_APP_LOGGING_LEVEL);
  return log;
}
